'use client'

import useBlogList from '../../../../core/hook/useBlogList'
import { BLOG_TYPE_TV, CmsBlogList, PAGE_SIZE_FOR_RUBRIC } from '../../../../domain/cmsBlogList'
import { useTranslation } from '../../../context/ConfigContext'
import AnimationEventOnBlogList from './AnimationEventOnBlogList'
import StickyYearOnBlogList from './StickyYearOnBlogList'

const BlogMessikaTvList = ({ initialData }: { initialData: CmsBlogList }) => {
  const { data, isLoading, fetchNextPage, isLastPage, page } = useBlogList(
    { blogType: BLOG_TYPE_TV, pageSize: PAGE_SIZE_FOR_RUBRIC[BLOG_TYPE_TV] },
    initialData,
  )
  const t = useTranslation()

  return (
    <div className='Blog-list-container'>
      <StickyYearOnBlogList isReady={!isLoading} />
      {data.items.map((item) => (
        <article
          className='Blog-list-item Blog-item with-messikatv-item-animation'
          data-year={item.date?.getFullYear() ?? null}
          data-id={item.id}
          key={item.id}>
          <div className='Blog-item-wrapper'>
            <div className='Blog-item-image Item--16_9'>
              <div className='content-wrapper'>
                <iframe
                  className='video-item-player'
                  id='player'
                  width='100%'
                  height='360'
                  src={item.url}
                  allowFullScreen
                  title={item.name}
                />
              </div>
            </div>
            <div className='Blog-item-info-wrapper'>
              <h2 className='Blog-item-title'>{item.name}</h2>
              <div className='Blog-item-date'>{item.date?.toLocaleDateString()}</div>
              <div
                className='Blog-item-description'
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          </div>
        </article>
      ))}
      {!isLastPage && (
        <div className='event-page-container-seemore'>
          <a
            href={`?page=${page}`}
            className='button'
            onClick={(e) => {
              e.preventDefault()
              e.nativeEvent.stopImmediatePropagation()
              e.currentTarget.blur()
              fetchNextPage()
            }}>
            <span className='snake' />
            <span className='snake__overlay' />
            {t('See more', {}, false)}
          </a>
        </div>
      )}
      <AnimationEventOnBlogList items={data.items} classNameItem='with-messikatv-item-animation' />
    </div>
  )
}

export default BlogMessikaTvList
